import React from 'react';

import PropTypes from 'prop-types';

import chiku from 'wanderu-assets/images/chiku.svg';

import styles from './ChikuLoader.scss';

const ChikuLoader = ({ children }) => {
    return (
        <div className={styles.chikuLoader}>
            <svg
                aria-valuemax={100}
                aria-valuemin={0}
                className={styles.spinner}
                fill="none"
                height="200"
                role="progressbar"
                viewBox="0 0 200 200"
                width="200"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path clipRule="evenodd" d="M200 100C200 155.228 155.228 200 100 200C44.7715 200 0 155.228 0 100C0 44.7715 44.7715 0 100 0V8C49.1898 8 8 49.1898 8 100C8 150.81 49.1898 192 100 192C150.81 192 192 150.81 192 100H200Z" fill="#00BFD5" fillRule="evenodd" />
                    <path clipRule="evenodd" d="M200 100C200 44.7715 155.228 0 100 0V8C150.81 8 192 49.1898 192 100H200Z" fill="#E2E2E2" fillRule="evenodd" />
                </g>
            </svg>
            {children || <img
                alt=""
                className={styles.chiku}
                src={chiku}
            />}
        </div>
    );
};

ChikuLoader.propTypes = {
    children: PropTypes.element,
};

export default ChikuLoader;
